module.exports = __webpack_public_path__ + "img/hbg.441ad8ab.png";